import SpeciesRow from "../../../SpeciesRow";
import AbstractField from "../AbstractField";

export default class SpeciesList extends AbstractField {
    species = null;

    setDrawMode(type) {
        this.species
            ? this.show()
            : this.hide();
    }

    setSpecies(speciesId) {
        this.species = this.speciesCollection.get(speciesId);
        this.setDrawMode();
        this.row = new SpeciesRow(this.provider, this.species, this.rowContainer);
    }

    make() {
        this.field = this.p.createDiv().class('input-group');
        this.label = this.p.createElement('h3', 'With species')
            .parent(this.field)
            .class('input-label')
            .style('margin-top', '0px');
        this.rowContainer = this.p.createDiv()
            .parent(this.field)
            .id('species-list');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.initialized = true;
        return this;
    }

    reset() {
        this.species = null;
    }
}
